<div class="modal-content">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p *ngIf="!isUpdate" class="modal-title h4" jhiTranslate="modals.addQuestionAnswer.title"></p>
    <p *ngIf="isUpdate" class="modal-title h4" jhiTranslate="modals.addQuestionAnswer.update.title"></p>
  </div>

  <form>
    <div class="modal-body text-left">
      <div class="row">
        <jhi-bary-input-text data-id-cypress="add-question" [control]="controls.question" [label]="'modals.addQuestionAnswer.input.question' | translate" class="col flex-grow-1">
        </jhi-bary-input-text>
        <jhi-bary-input-textarea data-id-cypress="add-answer" [control]="controls.answer" [label]="'modals.addQuestionAnswer.input.answer' | translate" class="col flex-grow-1">
        </jhi-bary-input-textarea>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <jhi-bary-button
        [outline]="true"
        class="mr-3"
        color="primary"
        [label]="'modals.addQuestionAnswer.buttons.cancel' | translate"
        (clickEvent)="handleClick({ first: true })"
      ></jhi-bary-button>
      <jhi-bary-button data-id-cypress="button-add-question-answer" (clickEvent)="handleSubmit()" [label]="setButtonLabel()" color="primary"></jhi-bary-button>
    </div>
  </form>
</div>
